import {
  PackageSchemaTypeEnum,
  PackageStatusDetailsLevelEnum,
  PackageStatusDetailsStatusEnum,
} from '../domain';
import { PackageMeta } from '../PackageMeta';
import { z } from 'zod';

export const CreatePackageByVersionBody = z
  .object({
    fileName: z.string().trim().optional(),
    fileNames: z.array(z.string()).optional(),
    name: z.string().trim().optional(),
    label: z.string().trim().optional(),
    description: z.string().optional(),
    categories: z.array(z.string()).optional(),
    packageMeta: PackageMeta,
    revisionId: z.string().optional(),
    status: z.nativeEnum(PackageStatusDetailsStatusEnum).optional(),
    level: z.nativeEnum(PackageStatusDetailsLevelEnum).optional(),
    data: z.any().optional(),
    schemaType: z.nativeEnum(PackageSchemaTypeEnum).optional(),
  })
  .transform((body) => {
    body.label = body.label || body.name;

    return body;
  });

export const CreatePackageReleaseBody = z
  .object({
    status: z
      .string()
      .transform(
        (status) => PackageStatusDetailsStatusEnum?.[status?.toUpperCase?.()],
      )
      .optional(),
    releaseNotes: z
      .union([
        z.string(),
        z
          .object({
            markdown: z.string().optional(),
          })
          .transform((s) => s?.markdown || ''),
      ])
      .transform((s) => s?.trim?.() || s)
      .optional(),
    membersAccountIds: z.array(z.string()).optional(),
    membersUserIds: z.array(z.string()).optional(),
    member: z
      .object({
        account: z
          .array(
            z.object({
              accountId: z.string(),
            }),
          )
          .optional(),
      })
      .optional(),
  })
  .transform((body) => {
    if (!body?.membersAccountIds?.length) {
      body.membersAccountIds =
        body.member?.account?.map((e) => e.accountId) || [];
    }

    return body;
  });

export const CreatePackageFromJsonBody = z.object({
  name: z.string(),
  description: z.string(),
  categories: z.array(z.string()).optional(),
  packageMeta: PackageMeta,
  data: z.any().optional(),
  schemaType: z.nativeEnum(PackageSchemaTypeEnum),
  isBeta: z.boolean().optional(),
});

export const DeprecateLegacyStepsBody = z.object({
  exclude: z.array(z.object({ id: z.string() })).default([]),
  include: z.array(z.object({ id: z.string() })).default([]),
});

export const PutLegacyPackageBody = z.object({
  name: z.string().default(''),
  description: z.string().default(''),
  categories: z.array(z.string()).default([]),
  data: z.any().default({}),
  updateSearch: z.boolean().optional()
});
